import { CampusDTO, CreateCampusDTO, EditCampusDTO } from './campus-profile.dto';
import { RootState } from '../../../../store/reducers';

export const selectCurrentCampus = (state: RootState): CreateCampusDTO | EditCampusDTO | CampusDTO =>
  state.campusProfile;
